enum FeesPayer {
  BENEFICIARY = 'BENEFICIARY',
  SENDER = 'SENDER',
}

export default FeesPayer;
